import { render, staticRenderFns } from "./CreateRequest.vue?vue&type=template&id=aea553dc&scoped=true&"
import script from "./CreateRequest.vue?vue&type=script&lang=js&"
export * from "./CreateRequest.vue?vue&type=script&lang=js&"
import style0 from "./CreateRequest.vue?vue&type=style&index=0&id=aea553dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea553dc",
  null
  
)

export default component.exports